import { computed } from "vue";
import globalSizes from "../assets/styles/global-grid-system.scss";
import { useResizeWindowHeightAndWidth } from "./use-resize-window-height-and-width";

export function useMediaQuery() {
  const { innerWidth } = useResizeWindowHeightAndWidth();

  const defaultSizes = {
    smBreakpoint: "600px",
    mdBreakpoint: "768px",
    lgBreakpoint: "992px",
    xlBreakpoint: "1200px",
  };
  const sizes = { ...defaultSizes, ...globalSizes };

  // Breakpoints are expected to be number of pixels: i.e. 100px
  const getPixelCount = (breakpoint: string): number =>
    parseInt(breakpoint.replace("px", ""));

  const smallWidthPixels = computed((): number =>
    getPixelCount(sizes.smBreakpoint)
  );
  const mediumWidthPixels = computed((): number =>
    getPixelCount(sizes.mdBreakpoint)
  );
  const largeWidthPixels = computed((): number =>
    getPixelCount(sizes.lgBreakpoint)
  );
  const extraLargeWidthPixels = computed((): number =>
    getPixelCount(sizes.xlBreakpoint)
  );

  const isSmallWidth = computed(
    (): boolean => innerWidth.value < smallWidthPixels.value
  );
  const isSmallerThanMediumWidth = computed(
    (): boolean => innerWidth.value < mediumWidthPixels.value
  );
  const isSmallerThanLargeWidth = computed(
    (): boolean => innerWidth.value < largeWidthPixels.value
  );
  const isSmallerThanExtraLargeWidth = computed(
    (): boolean => innerWidth.value < extraLargeWidthPixels.value
  );

  return {
    isSmallWidth,
    isSmallerThanMediumWidth,
    isSmallerThanLargeWidth,
    isSmallerThanExtraLargeWidth,
  };
}
